/** Отправка метрики о достигнутой цели. Для логирования отправляемых данных нужно добавить get параметр _ym_debug=1 */
export default function bootstrapYM() {
    /** Сохраненные метрики, которые не были отправлены ввиду недоступности скрипта */
    const stash: (() => void)[] = [];
    /** Доступность скрипта */
    let scriptLoaded = !!(window.ym && window.ymCounter);

    /**
     * При загрузке страницы скрипты метрики не доступны
     * Таймер периодически проверяет доступность скрипта.
     * Как только скрипт станет доступным - будут отправлены сохраненные метрики.
     */

    if (!scriptLoaded) {
        let timer = 0;

        timer = window.setInterval(() => {
            if (scriptLoaded) {
                clearInterval(timer);
                stash.forEach(fn => fn());

                return;
            }
            if (window.ym && window.ymCounter) scriptLoaded = true;
        }, 500);
    }

    return (goal: string, data?: Record<string, any>) => {
        const action = () =>
            window.ym?.(window.ymCounter, 'reachGoal', goal, {
                [goal]: data,
            });

        if (window.ym) action();
        else stash.push(action);
    };
}
